import React from "react";

function Line(){
    return(
        <div className="line"></div>
    )
}

export default Line